var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v("Assessment View")]),_c('b-container',{staticClass:"bv-example-row"},[(_vm.assessments.length)?[_c('AssessmentCard',{attrs:{"assessment_id":_vm.assessment_id,"tree_level":0}})]:_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }